<template>
  <div :class="$style.container">
    <div :class="$style.header">
      <div :class="$style.lang">
        <localization-controller :language="language" />
      </div>
    </div>

    <div :class="$style.content">
      <h1 :class="$style.title">{{ $t('deal.successful.title') }}</h1>
      <div :class="$style.description">
        <p>{{ $t('deal.successful.message') }}</p>
        <p>{{ $t('deal.successful.closed') }}</p>
      </div>

      <div :class="$style.images">
        <div :class="$style.shape">
          <img src="@/assets/images/safe-deal/shape.svg" alt="" />
        </div>
        <div :class="$style.confetti">
          <img src="@/assets/images/safe-deal/confetti.svg" alt="" />
        </div>
        <div :class="$style.people">
          <img src="@/assets/images/safe-deal/people.svg" alt="" />
        </div>
      </div>
    </div>

    <div :class="$style.footer">
      <div :class="$style.button">
        <simple-button variant="secondary" @click="handleRedirect">
          {{ $t('return.to.site') }}
        </simple-button>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleButton from 'molecules/common/SimpleButton';
import LocalizationController from 'organisms/localization/LocalizationController';

export default {
  name: 'SuccessfulSafeDeal',
  props: {
    language: {
      type: Object,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
  },
  components: {
    SimpleButton,
    LocalizationController,
  },
  methods: {
    handleRedirect() {
      window.location.assign(this.project.url);
    },
  },
};
</script>

<style lang="sass" module>
  .container
    width: 100%
    min-height: 100vh
    padding: 20px 0 50px
    display: flex
    flex-direction: column
    justify-content: space-between
    overflow: hidden

  .header
    margin-bottom: 10px
    padding: 0 14px
    display: flex
    flex-direction: column

    +respond-to('medium')
      margin-bottom: 0px
      padding: 0 70px

  .lang
    padding: 10px
    align-self: flex-end

  .title
    +deal-title
    margin-bottom: 10px
    color: rgba(124, 179, 66, 1)
    text-align: center

    +respond-to('medium')
      margin-bottom: 25px

  .description
    +deal-text
    margin-bottom: 26px
    color: rgba(33, 33, 33, 0.5)

    +respond-to('medium')
      margin-bottom: 26px

    p
      max-width: 240px
      margin: 0 auto
      text-align: center

  .content
    width: 100%
    max-width: 780px
    margin: 0 auto

  .images
    position: relative
    padding-bottom: 50px

    +respond-to('medium')
      padding-bottom: 0

  .shape
    text-align: center

    img
      width: 274px

      +respond-to('medium')
        width: auto

  .confetti
    position: absolute
    top: -25px
    left: 50%
    transform: translate(-50%)

    +respond-to('medium')
      top: -58px

    img
      width: 636px

      +respond-to('medium')
        width: auto

  .people
    width: 100%
    position: absolute
    top: 0
    display: flex
    justify-content: center

    +respond-to('medium')
      top: 30px

    img
      width: 379px

      +respond-to('medium')
        width: auto

  .footer
    margin-top: 30px

  .button
    max-width: 290px
    margin: 0 auto
    padding: 0 15px

    +respond-to('medium')
      max-width: 240px
</style>
